<template>
  <div class="tours">
    <div class="top">
      <div class="title">新闻中心</div>
    </div>
    <div class="lists" v-loading="loading">
      <div class="list" @click="toDetail(item)" v-for="item in list">
        <div class="img">
          <img :src="item.image_url" alt="">
        </div>
        <div class="list-cons">
          <div class="list-title u-line-1">{{ item.news_title }}</div>
          <div class="list-text u-line-2">{{ item.news_about }}</div>
        </div>
      </div>
    </div>
    <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize" background border
      layout="prev, pager, next" :total="total" @current-change="handleCurrentChange" />
  </div>
</template>

<script>

export default {
  data() {
    return {
      loading: false,
      total: 0,
      currentPage: 1,
      pageSize: 8,
      // typeList: [],
      list: [],
      currentNav: 0,
      navList: []
    }
  },
  mounted() {
    this.getNewGoodFn()
  },
  methods: {
    getListFn(item, index) {
      this.currentNav = index;
      this.getNewGoodFn()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`current page: ${val}`);
    },
    toDetail(item) {
      this.$router.push('/zh/newsDetail?news_id=' + item.news_id)
    },
    getNewGoodFn() {
      // 新闻中心列表
      this.loading = true
      this.$http.news_list_view({
        type_id: 755,
        page: this.currentPage,
        pagesize: this.pageSize,
      }).then(res => {
        console.log(res)
        this.list = res.data;
        this.total = res.count
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>

<style lang="less" scoped>
.tours {
  padding-bottom: 180px;
  background-color: #f1f1f1;

  .el-pagination {
    margin: 50px auto 120px;
    display: flex;
    justify-self: center;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #222222;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #222222;
  }

  .lists {
    display: flex;
    max-width: 1200px;
    margin: 0 auto;
    flex-wrap: wrap;
    padding-top: 40px;

    .list {
      width: calc(50% - 10px);
      background-color: #fff;
      border-radius: 6px;
      overflow: hidden;
      transition: .3s all;
      padding: 10px;
      box-sizing: border-box;
      box-shadow: 0 0 10px #ccc;
      cursor: pointer;
      transition: .3s all;
      display: flex;
      margin-right: 20px;
      margin-bottom: 20px;


      .img {
        width: 100px;
        height: 100px;
        overflow: hidden;
        border-radius: 5px;
        border: 2px solid #ccc;
        flex-shrink: 0;
        margin-right: 10px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: .3s all;
        }
      }

      &:hover {
        transform: scale(1.1);

        .name {
          color: #222222;
        }
      }

      .name {
        transition: .3s all;
        font-size: 17px;
        color: #333;
      }

      .list-cons {
        flex: 1;
      }

      .list-title {
        font-size: 20px;
        margin-bottom: 7px;
      }

      .list-text {
        color: #666;
        font-size: 15px;
      }
    }

    .list:nth-of-type(2n+1) {
      margin-right: 0;
    }
  }

  .nav {
    width: 100%;
    padding: 30px 0;
    background-color: #222222;

    .nav-con {
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      border-radius: 6px;

      .list {
        flex-shrink: 0;
        font-size: 16px;
        box-sizing: border-box;
        width: calc(50% - 15px);
        height: 45px;
        padding: 0 20px;
        margin: 0 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        justify-content: center;
        transition: .3s all;
        color: #fff;
        border-radius: 6px;
        position: relative;

        &::after {
          content: '';
          right: -20px;
          height: 30px;
          width: 1px;
          background-color: #fff;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      .list:nth-last-of-type(1)::after {
        content: none;
      }

      .list:hover,
      .list.active {
        color: #222222;
        background-color: #fff;
      }

    }
  }

  .top {
    width: 100vw;
    height: 340px;
    position: relative;
    overflow: hidden;
    background-image: url('../../assets/imgs/study_in_australia.jpg');
    background-size: auto 100%;
    transition: .3s all;
    background-position: center;

    .title {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 60px;
      font-weight: 600;
      letter-spacing: 2px;
      color: #222222;
      text-shadow: 3px 3px 5px #fff;
    }



    img {
      width: 100%;
      object-fit: cover;
      height: 100%;
      transition: .3s all;
    }

    &:hover {
      background-size: auto 110%;

      img {
        transform: scale(1.1);
      }
    }
  }


}

@media (max-width: 600px) {
  .tours {
    padding-bottom: 30px;

    .top {
      height: 200px;

      .title {
        font-size: 30px;
      }
    }

    .nav {
      padding: 15px 0;

      .nav-con {
        .list {
          font-size: 12px;
          height: 32px;
          margin: 5px 5px;
        }
      }
    }

    .lists {
      width: 100%;
      display: block;
      padding: 0 15px;
      box-sizing: border-box;

      .list {
        width: 100%;
        margin: 10px 0;

        .name {
          font-size: 14px;
        }
      }
    }

    .el-pagination {
      margin: 20px auto 50px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/zh/new.vue